// @ts-strict-ignore
import React from 'react'
import { useTranslation } from 'react-i18next'
import { DataListItem } from '@node-space/ui-components'
import { ellipseMiddleText } from '@node-space/utils'

interface TradeInSettlementProps {
  amountWithCurrency?: string
  transactionReference?: string
  merchantId?: string
  sender?: string
  beneficiary?: string
}

const TradeInSettlement = ({
  amountWithCurrency,
  transactionReference,
  merchantId,
  sender,
  beneficiary,
}: TradeInSettlementProps) => {
  const { t } = useTranslation()
  return (
    <>
      {amountWithCurrency && (
        <DataListItem
          id="amount-paid"
          testId="amount-paid"
          title={t('transactions.sideBar.paymentOutAmountPaid')}
          body={amountWithCurrency}
        />
      )}
      {merchantId && (
        <DataListItem
          id="merchant-id"
          testId="merchant-id"
          title={t('transactions.sideBar.merchantId')}
          body={merchantId}
        />
      )}
      {transactionReference && (
        <DataListItem
          id="transaction-reference"
          testId="transaction-reference"
          title={t('transactions.sideBar.reference')}
          body={ellipseMiddleText(transactionReference, 20, 10)}
          copyText={transactionReference}
        />
      )}
      <p className="text-h4 text-foreground-prominent mt-3">{t('senderDetails')}</p>
      {sender && (
        <DataListItem
          id="sender"
          testId="sender"
          title={t('transactions.sideBar.receivedFrom')}
          body={sender}
        />
      )}
      {beneficiary && (
        <DataListItem
          id="beneficiary"
          testId="beneficiary"
          title={t('transactions.sideBar.beneficiary')}
          body={beneficiary}
        />
      )}
    </>
  )
}

export default TradeInSettlement
